import system from "system-components"

const Link = system(
  {
    is: "a",
    fontSize: 2,
    fontWeight: "normal",
    color: "Ink",
    hover: {
      color: "Crimson",
    },
  },
  props => ({
    textDecoration: "none",

    "&:focus": {
      outline: "none",
    },
  }),
  "space",
  "width"
)

Link.displayName = "Link"

export default Link



// WEBPACK FOOTER //
// ./src/components/Link.js